/* eslint-disable no-undef */
import $ from "jquery";

const contentScroll = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    if ($('.site-main.AccountPage').length < 1) return;
    if (window.screen.width < 981) {
      $(function () {
        $('html').animate({
          scrollTop: $('#content-myaccount').offset().top - 100
        }, 'slow', 'swing')
      });
    }
  };

  init();
};

try {
  contentScroll();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
